<template>
  <div>
    <v-dialog persistent :value="productModal" width="500">
      <v-card>
        <v-card-title>Set Product Family</v-card-title>
        <v-card-text>
          <div class="mt-4">
            <v-select
              v-model="productFamily"
              :items="listItems"
              label="Product Family"
              dense
            ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="closeModal()"
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
            style="text-transform: capitalize;"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="updateData()"
            color="white"
            :class="
              $vuetify.breakpoint.width > 960
                ? 'ml-0 mr-0 primary'
                : 'ml-0 primary'
            "
            style="text-transform: capitalize;"
          >
            SET
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { LocationCategoryAPI } from '@/clients/location/location.category.api'

export default {
  data() {
    return {
      listItems: [
        { text: 'Cannabis', value: 'cannabis' },
        { text: 'Accessories', value: 'accessories' },
        { text: 'Retail', value: 'retail' }
      ],
      productFamily: 'cannabis'
    }
  },
  computed: {
    ...mapGetters({
      productModal: 'locationcategory/productPop',
      productObj: 'locationcategory/productObj'
    })
  },
  watch: {
    productModal(val) {
      if (val === true) {
        this.productFamily = 'cannabis'
      }
    }
  },
  mounted() {
    this.closeModal()
    this.spinner(false)
  },
  methods: {
    /**
     * Update
     */
    async updateData() {
      try {
        // Trigger apis
        this.spinner(true)
        let result = await LocationCategoryAPI.SetProductFamily({
          categoryId: this.productObj.id,
          product_family: this.productFamily
        })
        this.spinner(false)
        if (result.status === 200) {
          this.closeModal()
        }
        // Display message alert
        this.snackbar({
          text:
            result.status === 200
              ? result.data.msg
              : result.response.data.errors
              ? result.response.data.errors[0]
              : result.response.data.msg,
          open: true,
          color: result.status === 200 ? 'success' : 'error'
        })
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.errors
            ? err.response.data.errors[0]
            : err.response.data.message,
          open: true,
          color: 'error'
        })

        this.closeModal()
      }
    },

    /**
     * Close modal
     */
    closeModal() {
      this.setProductPop(false)
      this.setProductObj({})
    },

    ...mapActions({
      setProductPop: 'locationcategory/setProductPop',
      setProductObj: 'locationcategory/setProductObj'
    })
  }
}
</script>
